<template>
  <div class="pop-over">
    <div>
      <div class="description" v-if="!invalidFile">
        {{ $t('conformation_benchmark') }}
      </div>

      <div class="description" v-else>
        {{ $t('invalid_file') }}
      </div>


      <div class="button-footer">
        <div class="navigation-buttons">
          <button class="btn btn-outline-dark back" type="submit" @click="close">
            {{ $t('back_2') }}
          </button>
        </div>

        <div class="navigation-buttons" @click="getMetadata" v-if="!invalidFile">
          <button class="btn btn-outline-dark next" type="submit">
            {{ $t('continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'benchmarkDownload',
  props: {
    fileContent: ''
  },
  data() {
    return {
      invalidFile: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
      this.invalidFile = false;
    },
    getMetadata() {
      axios
        .get('https://mass.cloud.ut.ee/mass-v0/mass/2024-v1')
        .then(response => {
          this.$store.commit("addMetadata", response.data)
          this.$store.state.calculatedSummaryData = JSON.parse(this.fileContent)
          this.$store.state.answers['lastChangeDate'] = this.$store.state.calculatedSummaryData['lastChangeDate']

          this.getBenchmark();
        }).catch(function (error) {
          console.log("Failed to load data: ", error);


        })
    },
    validateFile() {
      if (this.$store.state.calculatedSummaryData.initial !== undefined &&
        this.$store.state.calculatedSummaryData.defined !== undefined &&
        this.$store.state.calculatedSummaryData.basic !== undefined &&
        this.$store.state.calculatedSummaryData.standard !== undefined &&
        this.$store.state.calculatedSummaryData.result !== undefined) this.invalidFile = false
      else this.invalidFile = true
    },

    // Quick fix for data sequence change
    changeSequence(array) {
      var list = []

      var newSequence = [
        "ISMS",
        "ORP",
        "CON",
        "OPS",
        "DER",
        "APP",
        "SYS",
        "IND",
        "NET",
        "INF"
      ]

      for (let i = 0; i < newSequence.length; i++) {
        list.push(array[newSequence[i]])
      }

      return list
    },

    getBenchmark() {
      this.validateFile()
      if (!this.invalidFile) {
        axios
          .get(this.$store.state.metadata.benchmark)
          .then(response => {
            this.$store.state.benchmark = [];
            this.benchmark = response.data;
            this.benchmark?.forEach(b => {
              let vals = this.changeSequence(b);

              this.$store.state.benchmark.push(
                {
                  "label": b.name[this.$i18n.locale],
                  "data": vals,
                }
              )
            })

            setTimeout(() => {
              this.showLoading = false;
              window.scrollTo(0, 0);
              this.$router.push('/results')

            }, 500);

          }).catch(function (error) {
            console.log("Failed to load data: ", error);
          })
      }

    }
  }
};
</script>

<style scoped>
.pop-over {
  background-color: #ffff;
  position: fixed;
  margin: auto;
  width: 500px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  border-radius: 15px;

}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 40px 10px 10px 0;
}

.btn {
  width: 180px;
}


.description {
  padding: 2rem;
  font-size: 1.2rem;
}
</style>
